import React, { useState } from 'react';
import styled from 'styled-components';
import { Level, Title } from 'rbx';
import moment from 'moment';
import qs from 'querystringify';
import { omit } from 'lodash';
import { withRouter } from 'react-router-dom';
import { Input, Radio } from '../../../components/elements';

const Wrapper = styled.nav`
  padding: 1rem;
  border-bottom: 1px solid #f5f8fa;
  padding-bottom: 1rem;
`;

const BoxWrapper = styled.nav`
  &&& {
    background: #f6f6f6;
  }
`;

const TitleWrapper = styled.nav`
  padding-right: 1rem;
`;

const Search = ({
  status,
  setStatus,
  voucherNameSearch,
  setVoucherNameSearch,
  eventStatus,
  setEventStatus,
  // handleSuburbNameSearch,
  // eventNameSearch,
  // suburbNameSearch,
  setLocation,
  placeNameSearchInput,
  setPlaceNameSearchInput,
  setStartDateRangeFilter,
  setEndDateRangeFilter,
  voucherCodeSearch,
  setVoucherCodeSearch,
  routeState,
  history,
  place_name,
  voucher_code,
  name,
}) => {
  const [city, setCity] = useState('');

  const handlePush = (args, key) => {
    const newRoutState = omit(routeState, key);
    history.push(
      `/event-deals${qs.stringify(
        {
          ...newRoutState,
          ...args,
        },
        true,
      )}`,
    );
  };

  return (
    <Wrapper>
      <Level>
        <Level.Item align="left">
          <Level.Item>
            <TitleWrapper>
              <Title className="label">Status</Title>
            </TitleWrapper>
          </Level.Item>
          <Level.Item>
            <Radio
              label="Current"
              value={status === 'current'}
              onChange={() => {
                setStatus('current');
                setStartDateRangeFilter({
                  end_date: moment().format('YYYY-MM-DD'),
                });
                // setEndDateRangeFilter({
                //   start_date: moment(
                //     `${moment().format('L')} 11:59 PM`,
                //   ).toISOString(),
                // });
                setEndDateRangeFilter({
                  start_date: moment().format('YYYY-MM-DD'),
                });
              }}
            />
          </Level.Item>
          <Level.Item>
            <Radio
              label="Past"
              value={status === 'past'}
              onChange={() => {
                setStatus('past');
                // setEndDateRangeFilter({
                //   end_date: moment(`${moment().format('L')} 12:00 AM`)
                //     .subtract(1, 'day')
                //     .toISOString(),
                // });
                setEndDateRangeFilter({
                  end_date: moment().toISOString(),
                });
                setStartDateRangeFilter();
              }}
            />
          </Level.Item>
          <Level.Item>
            <Radio
              label="Future"
              value={status === 'future'}
              onChange={() => {
                setStatus('future');
                setStartDateRangeFilter({
                  start_date: moment(`${moment().format('L')} 12:00 AM`)
                    .add(1, 'day')
                    .toISOString(),
                });
                setEndDateRangeFilter();
              }}
            />
          </Level.Item>
        </Level.Item>
        <Level.Item align="right">
          <Level.Item>
            <TitleWrapper>
              <Title className="label">Event Deal Status</Title>
            </TitleWrapper>
          </Level.Item>
          <Level.Item>
            <Radio
              label="Active"
              value={eventStatus === 'ACTIVE'}
              onChange={() =>
                handlePush({ eventStatus: 'ACTIVE' }, 'eventStatus')
              }
            />
          </Level.Item>
          <Level.Item>
            <Radio
              label="Inactive"
              value={eventStatus === 'INACTIVE'}
              onChange={() =>
                handlePush({ eventStatus: 'INACTIVE' }, 'eventStatus')
              }
            />
          </Level.Item>
        </Level.Item>
      </Level>
      <BoxWrapper className="box">
        <div className="columns">
          <div className="column is-4">
            <Input
              label="Voucher Name"
              type="text"
              value={name}
              onChange={event => {
                handlePush({ name: event.target.value }, 'name');
              }}
              placeholder="Start entering voucher name..."
            />
          </div>

          <div className="column is-4">
            <Input
              label="Voucher Code"
              type="text"
              value={voucher_code}
              onChange={event => {
                handlePush(
                  { voucher_code: event.target.value },
                  'voucher_code',
                );
              }}
              placeholder="Start entering voucher code..."
            />
          </div>

          <div className="column is-one-quarter">
            <Input
              label="Place Name"
              type="text"
              value={place_name}
              onChange={event => {
                handlePush({ place_name: event.target.value }, 'place_name');
              }}
              placeholder="Start entering place name..."
            />
          </div>
        </div>
      </BoxWrapper>
    </Wrapper>
  );
};

export default withRouter(Search);
